import { render, staticRenderFns } from "./TheRestoreBanner.vue?vue&type=template&id=f3c0a364&scoped=true&"
import script from "./TheRestoreBanner.vue?vue&type=script&lang=js&"
export * from "./TheRestoreBanner.vue?vue&type=script&lang=js&"
import style0 from "./TheRestoreBanner.vue?vue&type=style&index=0&id=f3c0a364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c0a364",
  null
  
)

export default component.exports